import {useLocation, useOutletContext} from "react-router-dom";

import {useErrors} from "base/error/provider";
import {useDownload} from "base/file/utilities";
import {useNavigateWithReload} from "base/navigation/hooks";
import {usePermitExtensionForm} from "permitextension/hooks";
import {PermitExtensionService} from "permitextension/service";

import {FormCheckbox, FormContainer} from "base/form/components";
import {PermitExtensionForm} from "./form";
import {DownloadPDFButton} from "base/pdf/presentational";
import Stack from "@mui/material/Stack";

const PermitExtensionSignatureStep = () => {
    const download = useDownload();
    const navigate = useNavigateWithReload();

    const {extension, isStepEditable} = useOutletContext();
    const {handleErrors} = useErrors();

    const basePath = useLocation();
    const fileFields = ["payment_receipt"];

    const {handleFormSubmit} = usePermitExtensionForm(extension, basePath, fileFields);

    const handleDownload = () => {
        if (extension) {
            return PermitExtensionService.download(extension.id).then(response => {
                return download(response)
                    .then(() => navigate("", true))
                    .catch(error => handleErrors(error));
            });
        } else {
            return Promise.reject("Nenhuma autorização foi selecionada.");
        }
    };

    return extension ? (
        <>
            <Stack alignItems="center" pb={2}>
                <DownloadPDFButton
                    handleGeneratePDF={handleDownload}
                    text="Imprimir prorrogação"
                    color="secondary"
                />
            </Stack>
            <FormContainer style={{alignItems: "center"}}>
                <PermitExtensionForm entity={extension} onSubmit={handleFormSubmit}>
                    <Stack mt={1}>
                        <FormCheckbox
                            name="extension_sent"
                            label="A prorrogação foi enviada para a Direcção"
                            disabled={!isStepEditable}
                            style={{py: 0}}
                        />
                        <FormCheckbox
                            name="extension_signed"
                            label="A prorrogação foi assinada pela Direcção"
                            disabled={!isStepEditable}
                            style={{py: 0}}
                        />
                    </Stack>
                </PermitExtensionForm>
            </FormContainer>
        </>
    ) : null;
};

export default PermitExtensionSignatureStep;
